import BowCompass from "../../../../Assets/Icons/BowCompass.svg";
import classes from "./InitiatedDummy.module.css";

export const InitiatedDummy = ({ title, description }) => {
    return (
        <div className={classes.root}>
            <img src={BowCompass} alt="" />
            <p className={classes.title}>{title}</p>
            <p className={classes.description}>{description}</p>
        </div>
    );
};
